// Client-side validation rules for Notice Management, aligned with the canonical
// input-validation standard ([공통] 00_입력검증표준 v1.1, 2026-07-10):
//   - Title (TITLE class): 2–100 chars, general special chars allowed, emoji NOT
//     allowed (§4.2 — 이모지 전 클래스 불허).
//   - Content (rich text): non-empty, max 20,000 chars INCLUDING HTML tags (§7-k),
//     and emoji-free too (SHCT-858 — §4.2 defines no RICHTEXT class, so 리치텍스트
//     is exempt from the LENGTH table only, never from the character policy).
// Kept i18n-free so they can be reused by the form and the mock adapter and
// unit-tested without a renderer.

import { hasEmoji, hasEmojiInRichText } from '@/shared/utils/emoji';
import { RICH_TEXT_MAX, isRichTextTooLong } from '@/shared/utils/rich-text-length';

// SHCT-858 — the emoji rule is app-wide (§4.2 bans it for every class), so it now
// lives in `@/shared/utils/emoji`. Re-exported here so the form's existing
// imports keep working.
export { hasEmoji, hasEmojiInRichText };

export const TITLE_MIN = 2;
export const TITLE_MAX = 100;
// SHCT-703 — the rich-text cap is not a notice rule, it is the [공통] 00 §3
// exception that also governs 약관 본문, so it moved to
// `@/shared/utils/rich-text-length`. Aliased here so existing imports keep working.
export const CONTENT_MAX = RICH_TEXT_MAX;

// Strip tags + &nbsp; to decide whether the RTE body has real content.
export function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
}

export function hasContent(html: string | undefined): boolean {
  if (!html) return false;
  return stripHtml(html).length > 0;
}

export function isTitleLengthValid(trimmed: string): boolean {
  return trimmed.length >= TITLE_MIN && trimmed.length <= TITLE_MAX;
}

// Raw HTML length (tags included) over the cap.
export function isContentTooLong(html: string): boolean {
  return isRichTextTooLong(html);
}
